import {DateTime} from "luxon";

// A licence date is a calendar date with no time zone. Sent as an instant, the browser's zone decides the date the
// API keeps, so east of UTC a picked date would be saved a day early.
export function toLicenceDate(valueP: DateTime | string | null | undefined): string | null {
  if (!valueP) {
    return null;
  }

  if (DateTime.isDateTime(valueP)) {
    return valueP.isValid ? valueP.toISODate() : null;
  }

  // A stored date shown back in the edit dialog as a UTC "yyyy-MM-dd..." string: its first ten characters are the date.
  return /^\d{4}-\d{2}-\d{2}/.test(valueP) ? valueP.substring(0, 10) : null;
}
